import Image from 'next/image';

export default function ApplicationAreas () {
    return(
    <div className="application-areas">
      <div className="area">
        <h3>Будівництво</h3>
        <ul>
          <li>Каркаси будівель</li>
          <li>Армування фундаментів</li>
          <li>Металеві покрівельні матеріали</li>
          <li>Виготовлення воріт і дверей</li>
        </ul>
        <Image src="/images/applications/construction.jpg" alt="Застосування у будівництві" width={400} height={300} />
      </div>
      
      <div className="area">
        <h3>Машинобудування</h3>
        <ul>
          <li>Корпуси механізмів</li>
          <li>Двигунні елементи</li>
          <li>Трансмісії</li>
        </ul>
        <Image src="/images/applications/machinery.jpg" alt="Застосування у машинобудуванні" width={400} height={300} />
      </div>
      
      <div className="area">
        <h3>Енергетика</h3>
        <ul>
          <li>Опори ЛЕП</li>
          <li>Конструкції трансформаторів</li>
          <li>Монтажні мачти</li>
        </ul>
        <Image src="/images/applications/energy.jpg" alt="Застосування у енергетиці" width={400} height={300} />
      </div>
    </div>
    )
}